import React, { useState } from "react";
import { Grid, Card, CardContent, Collapse } from "@material-ui/core/";
import SummaryHeader from "../SummaryContent/SummaryHeader";

export default function Collapsable(props) {
    const { title, children } = props;
    const [expanded, setExpanded] = useState(true);

    const handleExpandedClick = () => {
        setExpanded(!expanded);
    };

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card>
                <SummaryHeader
                    title={title}
                    handleFunction={handleExpandedClick}
                    valueExpanded={expanded}
                ></SummaryHeader>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Grid container spacing={2}>
                            {children}
                        </Grid>
                    </CardContent>
                </Collapse>
            </Card>
        </Grid>
    );
}
